/* eslint-disable @typescript-eslint/no-explicit-any */

import React, { type JSX, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import styled from 'styled-components';

import { Page } from '../../components';
import CardsAccordion from '../../components/CardsAccordion';
import { logger } from '../../features/logger';
import { withAPIService } from '../../networking';
import { withStore } from '../../store';

const CompanyCardWrapper = styled.div`
  width: 100%;
  margin-bottom: 24px;
`;

const WrapperContainer = styled.div`
  width: 100%;
`;

interface FinancialPageProps {
  store: any;
  cards?: any[];
  dispatch?: any;
}

function Component(props: FinancialPageProps): JSX.Element {
  const { store, cards = [], dispatch } = props;

  const { customer, common } = store;
  const { lineOfCredit } = customer;
  const { policyAccepted } = common;

  const { t } = useTranslation();

  let finalCardList: any[] = [];

  const [expandedAccordion, setExpandedAccordion] = useState<any>(0);

  const [cardList, setCardList] = useState<any[]>([]);

  useEffect(() => {
    logger.info(`RED-CARPET-FE Financial Page`, {
      hcRequestId: store.customer.id
    });

    filterFinancialPage();
  }, []);

  const filterFinancialPage = () => {
    finalCardList = cards.filter((card: any) => {
      if (!lineOfCredit) {
        return card.key !== 'financialAttachmentCard';
      }

      if (policyAccepted) {
        return card.key !== 'privacyPolicy';
      }

      return cards;
    });

    setCardList(finalCardList);
  };

  const accordionCallback = (index: number) => {
    setExpandedAccordion(index);
  };

  return (
    <Page {...props} dispatch={dispatch}>
      <WrapperContainer>
        {cardList.map(({ key, ...card }: any, index: number) => {
          const title = t(`financial.${key}.title`);

          const { Component } = card;

          const cardProps = {
            title: t(`financial.${key}.subtitle`),
            image: '/food/onboarding/assets/Tooltip.svg'
          };

          return (
            <React.Fragment key={title}>
              {(key === 'financialAttachmentCard' && !lineOfCredit) ||
              (key === 'privacyPolicy' && policyAccepted) ? null : (
                <CompanyCardWrapper>
                  <CardsAccordion
                    accordionCallback={accordionCallback}
                    isOpen={expandedAccordion === index}
                    cardTitle={title}
                    cardIndex={index}
                    cardProps={cardProps}
                  >
                    <Component {...props} {...card} index={0} />
                  </CardsAccordion>
                </CompanyCardWrapper>
              )}
            </React.Fragment>
          );
        })}
      </WrapperContainer>
    </Page>
  );
}

const connectAPI = withAPIService(Component);
const FinancialPage = withStore(connectAPI);

export default FinancialPage;
